import { CatalogService } from './CatalogService';

export class BankAcquirerService extends CatalogService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
}
// import {AppEntities, AppServices} from "../../config/entities";

// export class BankAcquirerService {
//     async GetAll(searchText: string | undefined) {
//         console.log("GetAll");
//         let url = AppEntities.BankAcquirer.apiUrl;
//         if (searchText) {
//             url += "?searchText=" + searchText;
//         }

//         const response = await AppServices.Axios.get(url);
//         return response.data;
//     }

//     async GetAllCustomers(searchText: string | undefined) {
//         console.log("GetAll");
//         let url = AppEntities.BankAcquirer.apiUrl + "/customers";
//         if (searchText) {
//             url += "?searchText=" + searchText;
//         }

//         const response = await AppServices.Axios.get(url);
//         return response.data;
//     }

//     async GetAllPriceTypes (searchText: string | undefined) {
//         console.log("GetAll");
//         let url = AppEntities.BankAcquirer.apiUrl + "/BankAcquirer";
//         if (searchText) {
//             url += "?searchText=" + searchText;
//         }

//         const response = await AppServices.Axios.get(url);
//         return response.data;
//     }    

//     async Get(id: string) {
//         console.log("Get", id);
//         const response = await AppServices.Axios.get(AppEntities.BankAcquirer.apiUrl + "/" + id);
//         return response.data;
//     }

//     async Delete(selectedItemId: string | null) {
//         if (selectedItemId) {
//             console.log("Delete", selectedItemId);
//             const response = await AppServices.Axios.delete(AppEntities.BankAcquirer.apiUrl + "/" + selectedItemId);
//             console.log("Delete response", response);
//         }
//     }

//     async Update(model: any) {
//         console.log("Update", model);
//         const response = await AppServices.Axios.put(AppEntities.BankAcquirer.apiUrl, model);
//         console.log("Update response", response);
//     }

//     async Create(model: any) {
//         console.log("Create", model);
//         const response = await AppServices.Axios.post(AppEntities.BankAcquirer.apiUrl, model);
//         console.log("Create response", response);
//     }
// }